import { computed } from 'vue'

import { useCookie } from '@/composables/useCookie'
import {
  ADDRESS_COOKIE,
  ADDRESS_ID_COOKIE,
  LATITUDE_COOKIE,
  LONGITUDE_COOKIE,
} from '@/constants/storage'

/** Порядок как в Яндекс.Картах: [долгота, широта]. */
export type LngLat = [number, number]

/** Центр Ташкента — куда смотрит карта, пока точка не выбрана. */
export const DEFAULT_CENTER: LngLat = [69.27979, 41.311184]

/** Координаты точки доставки — в cookie, их читает запрос меню. */
export function useLocation() {
  const longitude = useCookie(LONGITUDE_COOKIE)
  const latitude = useCookie(LATITUDE_COOKIE)

  /*
   * Название точки храним рядом с координатами. По координатам его не
   * восстановить: в справочнике адрес ищется по радиусу 50 метров, и стоит
   * промахнуться — экран говорит «Укажите адрес», хотя точка выбрана,
   * а в заказ уходит пустая строка адреса.
   */
  const addressName = useCookie(ADDRESS_COOKIE)

  /**
   * Какую запись справочника выбрал клиент. Ноль — точка на карте, которой
   * в справочнике ещё нет: так бывает до того, как её сохранили формой.
   */
  const addressIdCookie = useCookie(ADDRESS_ID_COOKIE)
  const addressId = computed(() => Number(addressIdCookie.value) || 0)

  const longLat = computed<LngLat>(() => [Number(longitude.value) || 0, Number(latitude.value) || 0])

  const hasCoordinates = computed(() => longLat.value[0] !== 0 && longLat.value[1] !== 0)

  function setLongLat(value: LngLat): void {
    longitude.value = value[0] ? String(value[0]) : ''
    latitude.value = value[1] ? String(value[1]) : ''
  }

  function setAddressName(value: string): void {
    addressName.value = value
  }

  function setAddressId(value: number): void {
    addressIdCookie.value = value ? String(value) : ''
  }

  return {
    longLat,
    hasCoordinates,
    addressName,
    addressId,
    setLongLat,
    setAddressName,
    setAddressId,
  }
}
